import React, { useState } from 'react';
import { db } from '../firebaseConfig';
import { collection, addDoc, Timestamp } from 'firebase/firestore';
import { toast } from 'react-toastify';

function EventForm({ clubId, onCancel, onSuccess }) {
    const [formData, setFormData] = useState({
        name: '',
        date: '',
        time: '18:00',
        description: ''
    });
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formData.name || !formData.date) {
            toast.error('Please fill in required fields.');
            return;
        }

        setIsSubmitting(true);

        try {
            // Construct event start time
            const startDateTime = new Date(`${formData.date}T${formData.time}`);

            await addDoc(collection(db, 'events'), {
                clubId,
                name: formData.name,
                startTime: Timestamp.fromDate(startDateTime),
                description: formData.description,
                createdAt: Timestamp.now()
            });

            toast.success('Event added successfully!');
            if (onSuccess) onSuccess();
        } catch (error) {
            console.error('Error adding event:', error);
            toast.error('Failed to add event.');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="mt-4 p-4 bg-gray-50 rounded-lg border border-gray-200 animate-fade-in-up">
            <h4 className="font-bold text-gray-700 text-sm mb-3">Add New Event</h4>
            <form onSubmit={handleSubmit} className="space-y-3">
                <input
                    type="text"
                    placeholder="Event Name (e.g. Saturday Rapid)"
                    className="w-full text-sm border rounded px-2 py-1"
                    value={formData.name}
                    onChange={e => setFormData({ ...formData, name: e.target.value })}
                    required
                />

                <div className="grid grid-cols-2 gap-2">
                    <input
                        type="date"
                        className="w-full text-sm border rounded px-2 py-1"
                        value={formData.date}
                        onChange={e => setFormData({ ...formData, date: e.target.value })}
                        required
                    />
                    <input
                        type="time"
                        className="w-full text-sm border rounded px-2 py-1"
                        value={formData.time}
                        onChange={e => setFormData({ ...formData, time: e.target.value })}
                        required
                    />
                </div>

                <textarea
                    placeholder="Description / Details (Optional)"
                    className="w-full text-sm border rounded px-2 py-1"
                    rows="3"
                    value={formData.description}
                    onChange={e => setFormData({ ...formData, description: e.target.value })}
                />

                <div className="flex gap-2 pt-2">
                    <button
                        type="button"
                        onClick={onCancel}
                        className="flex-1 bg-white border border-gray-300 text-gray-600 text-xs py-1.5 rounded"
                    >
                        Cancel
                    </button>
                    <button
                        type="submit"
                        disabled={isSubmitting}
                        className="flex-1 bg-indigo-600 text-white text-xs py-1.5 rounded hover:bg-indigo-700"
                    >
                        {isSubmitting ? 'Adding...' : 'Add Event'}
                    </button>
                </div>
            </form>
        </div>
    );
}

export default EventForm;
